<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getLogs"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
            <Row :gutter="16">

                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">操作日志列表</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            @click="onExport">导出</Button>
                            <Button
                            type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            @click="openCloumnDescModal()"
                            >字段说明</Button>
                    </div>

                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getLogs"
                        :autoHeight = "true"
                        :totalSummaryFieldDatas="mainTable.sumData"
                        :showPage="true" />
                </Col>
            </Row>
        </Card>
        <cloumn-desc-modal ref="cloumnDescModal" />
        <seedfarm-accept-cusmgr-modal ref="seedfarmAcceptModal" />
        <presale-plan-modal ref="presalePlanModal" />
    </div>
</template>

<script>
import search from "@/libs/search";
import StandPaginationTable from '@/components/pagination-table/pagination-table.vue';
import { getLogList } from '@/api/modules/system-management/log-management';
import SearchCard from '@/components/searchCard/searchCard.vue';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import CloumnDescModal from './cloumn-desc-modal.vue';
import SeedfarmAcceptCusmgrModal from './seedfarm-accept-cusmgr-modal.vue';
import presalePlanModal from "./presale-plan-modal.vue";    
export default {
    name: "LogManagement",
    components: {
        StandPaginationTable,
        SearchCard,
        CloumnDescModal,
        SeedfarmAcceptCusmgrModal,
        presalePlanModal
    },

    data() {
        return {
            loading: false,
            logs: [],
            total: 0,
            page: 1,
            pageSize: 10,
            searchForm: {
                operationType: "",
                operatorUsername: "",
                dateRange: []
            },
            mainTable:{
                columns: [
                    {
                        title: "时间",
                        key: "CreateTime",
                        width: 150,
                        align: 'center',
                        render: (h, params) =>
                            h(
                                "span",
                                params.row.CreateTime
                                    ? params.row.CreateTime
                                        .substr(0, 19)
                                        .replace("T", " ")
                                    : ""
                            )
                    },
                    {
                        title: "类型",
                        key: "OperationType",
                        width: 80,
                        align: 'center',
                        render: (h, params) =>
                            h(
                                "span",
                                params.row.OperationType==1
                                    ? "新增":params.row.OperationType==2?"删除"
                                        : params.row.OperationType==3?"修改"
                                            : "未知状态"
                            ) },
                    { 
                        title: "来源", 
                        key: "Source", 
                        width: 100, 
                        align: 'center',
                        render: (h, params) => {
                            // 安全检查：确保params.row存在
                            if (!params || !params.row) {
                                return h('span', '');
                            }
                            
                            const source = params.row.Source;
                            if (source === '认可关系列表') {
                                return h('span', {
                                    style: {
                                        color: '#2d8cf0',
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    },
                                    on: {
                                        click: () => {
                                            this.showSeedfarmAcceptDetail(params.row.TargetID);
                                        }
                                    }
                                }, source);
                            }
                            else if (source === '供货计划') {
                                return h('span', {
                                    style: {
                                        color: '#2d8cf0',
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    },
                                    on: {
                                        click: () => {
                                            this.showPresalePlanDetail(params.row.TargetID, params.row.OldValue, params.row.NewValue, params.row.CreateTime);
                                        }
                                    }
                                }, source);
                            }
                            else {
                                return h('span', source || '');
                            }
                        }
                    },
                    { title: "操作人", key: "OperatorUsername", width: 100, align: 'center' },
                    { title: "说明", key: "Meg", align: 'center' },
                    { title: "修改前", key: "OldValue", width: 100, align: 'center' },
                    { title: "修改后", key: "NewValue", width: 100, align: 'center' },
                    { title: "商品编号", key: "combinedProductCode", align: 'center' },
                    { title: "商品名称", key: "combinedProductName", align: 'center' },
                    { title: "供货计划年", key: "preSalePlanYear", align: 'center' },
                    { title: "供货计划月", key: "preSalePlanWeek", align: 'center' },
                    { title: "客户编号", key: "customerUserName", align: 'center' },
                    { title: "客户姓名", key: "customerPersonName", align: 'center' },
                    { title: "客户电话", key: "customerPhone", align: 'center' }
                    /* { title: "供货计划商品编号", key: "preSalePlanProductCode", align: 'center' },
                    { title: "供货计划商品名", key: "preSalePlanProductName", align: 'center' },
                    { title: "定金单编号", key: "depositBillCode", align: 'center' },
                    { title: "定金单商品编号", key: "depositBillProductCode", align: 'center' },
                    { title: "定金单商品名", key: "depositBillProductName", align: 'center' },
                    { title: "发货单编号", key: "preSaleDeliveryCode", align: 'center' },
                    { title: "发货单商品编号", key: "preSaleDeliveryProductCode", align: 'center' },
                    { title: "发货单商品名", key: "preSaleDeliveryProductName", align: 'center' } */
                ],
                data: [],
                sumData: [],
                searchForm: [
                    { label: '来源', type: 'Input', value: '', name: 'ol.Source', sql: 'like' },
                    { label: '操作人', type: 'Input', value: '', name: 'ol.OperatorUsername', sql: 'like' },
                    { label: '商品编号', type: 'Input', value: '', name: 'CONCAT(pspProduct.productCode, ded.depositBillDetailProductCode, psdd.productCode)', sql: 'like' },
                    { label: '定金单', type: 'Input', value: '', name: 'depositBillRecordCode', sql: 'eq' },
                    { label: '发货单', type: 'Input', value: '', name: 'psdr.preSaleDeliveryRecordCode', sql: 'eq' },
                    { label: '说明', type: 'Input', value: '', name: 'ol.Meg', sql: 'like' },
                    { label: '操作日期', type: 'Daterange', value: '', name: 'ol.CreateTime', sql: 'dateBetween' },
                    { label: '客户信息', type: 'Input', value: '', name: 'CONCAT(u.userName, ibru.userName, u.userPersonName, ibru.userPersonName, uec.userExternalCustomerPhone, ibruc.userExternalCustomerPhone)', sql: 'like' },
                    { label: '供货计划年', type: 'Input', value: '', name: 'psp.preSaleYear', sql: 'eq' },
                    { label: '供货计划月', type: 'Input', value: '', name: 'psp.preSaleWeek', sql: 'eq' }

                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }

        };
    },
    methods: {
        getLogs() {
            getLogList(this.mainTable.tableSearch)
                .then((res) => {
                    this.loading = false;
                    if (res.code === 0) {
                        if (res.code === 0) {
                            this.mainTable.data = res.data.records;
                            this.mainTable.sumData = res.data.sumRecord;
                            search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                        }
                        this.mainTable.loading = false;
                    }
                });
        },
        onExport(){
            this.loading = true;
            this.mainTable.tableSearch.excelExport.enable = true;
            getLogList(this.mainTable.tableSearch)
                .then((res) => {
                    this.loading = false;
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                        // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                    }
                });
        },
        openCloumnDescModal() {
            this.$refs.cloumnDescModal.openColumnDescModal();
        },
        // 显示认可关系详情
        showSeedfarmAcceptDetail(id) {
            
            // 构造示例数据，实际应用中这里会传入真实的数据
            this.$refs.seedfarmAcceptModal.open(id);
        },
        // 显示供货计划详情
        showPresalePlanDetail(id, oldValue, newValue, createTime) {
            // 构造示例数据，实际应用中这里会传入真实的数据
            this.$refs.presalePlanModal.open(id, oldValue, newValue, createTime);
        }
    },
    mounted() {
        this.getLogs();
    }
};
</script>

<style lang="less" scoped>
.global-tool-bar {
    margin-bottom: 16px;
    .title {
        font-size: 18px;
        font-weight: bold;
    }
}
</style>